import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

const Layout = () => {
  return (
    <div className="sfm-layout">
      <Header />
      <main className="sfm-main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
